<div class="tile">
  <h5>{{ 'statistics.weighting.headline' | transloco }}</h5>
  <div class="row">
    <div class="col-12">
      <div class="nav nav-tabs mt-1">
        <ng-template #nav let-weightingType="weightingType">
          <div class="nav-item">
            <a
              [attr.data-zid]="'weighting-type-tab-' + WeightingType[weightingType]"
              (click)="weightingTypeChange.emit(weightingType)"
              class="nav-link cursor-pointer font-medium"
              [class.active]="type === weightingType"
            >
              {{ 'statistics.weighting.tabs.' + WeightingType[weightingType] | transloco }}
            </a>
          </div>
        </ng-template>
        <ng-container [ngTemplateOutlet]="nav" [ngTemplateOutletContext]="{ weightingType: WeightingType.ASSETS }" />
        <ng-container [ngTemplateOutlet]="nav" [ngTemplateOutletContext]="{ weightingType: WeightingType.TOP_POSITIONS }" />
      </div>
    </div>
  </div>
  @if (!loading) {
    @if (config && config[0]) {
      <div class="row d-flex justify-content-center align-items-center">
        <div class="chart-container">
          <canvas data-zid="weighting-chart" baseChart [datasets]="config" [options]="options" [legend]="false" type="doughnut"></canvas>
        </div>
      </div>
      <div class="row mt-3 legend">
        @for (item of config[0]['data']; track i; let i = $index) {
          <ng-template #legendItem>
            <div
              class="col-6 col-lg-12 col-xl-6 d-flex align-items-center font-size-smaller1 mb-2 legend-item"
              [title]="legendLabels[i] | transloco"
            >
              <span class="legend-circle mr-2" [style]="{ 'background-color': colors[i] }"></span>
              {{ item | volumePercentage: weighting.totalVolumesSum }} {{ legendLabels[i] | transloco }}
            </div>
          </ng-template>
          @if (legendPaging) {
            @if (i >= legendPaging.from && i < legendPaging.to) {
              <ng-container [ngTemplateOutlet]="legendItem" />
            }
          } @else {
            <ng-container [ngTemplateOutlet]="legendItem" />
          }
        }
      </div>
      <div class="row mt-3 legend-paging">
        <div class="col-12 d-flex">
          <div class="expand no-select" (click)="openModal()">
            <div class="mr-1 color-secondary">{{ 'statistics.weighting.expand' | transloco }}</div>
            <web-design-system-icon size="small" name="expand" color="action" />
          </div>
          <div class="paging-circles opacity-container" [class.active]="legendPaging">
            @if (legendPaging?.items) {
              @for (_ of legendPaging.items | numberToArray; track i; let i = $index) {
                <div [class.active]="legendPaging.current === i" (click)="useLegendPaging(i)"></div>
              }
            }
          </div>
        </div>
      </div>
    } @else {
      <div data-zid="no-data">{{ 'statistics.weighting.no-data' | transloco }}</div>
    }
  } @else {
    <div class="row mb-2 d-flex justify-content-center">
      <div class="col-12 loading-shimmer chart"></div>
    </div>
    <div class="row pl-2 pr-2">
      <div class="col-6 mb-2">
        <div class="loading-shimmer trade-tick"></div>
      </div>
      <div class="col-6 mb-2">
        <div class="loading-shimmer trade-tick"></div>
      </div>
      <div class="col-6">
        <div class="loading-shimmer trade-tick"></div>
      </div>
      <div class="col-6">
        <div class="loading-shimmer trade-tick"></div>
      </div>
    </div>
    <div class="row legend-paging"></div>
  }
</div>

<ng-template #modalContent let-modal>
  <web-design-system-modal (dismiss)="modal.dismiss()">
    <div class="row align-items-center mt-5">
      <div class="col-7 d-flex justify-content-center align-items-center">
        <div class="chart-container expand">
          <canvas data-zid="weighting-chart" baseChart [datasets]="config" [options]="options" [legend]="false" type="doughnut"></canvas>
        </div>
      </div>
      <div class="col-5 legend-col">
        <div class="row legend justify-content-center">
          @if (weighting) {
            @for (item of config[0]['data']; track i; let i = $index) {
              <div class="col-12 d-flex align-items-center mb-2 legend-item expand" [title]="legendLabels[i] | transloco">
                <span class="legend-circle mr-2" [style]="{ 'background-color': colors[i] }"></span>
                {{ item | volumePercentage: weighting.totalVolumesSum }} {{ legendLabels[i] | transloco }}
              </div>
            }
          }
        </div>
      </div>
    </div>
  </web-design-system-modal>
</ng-template>
